<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="subcontent">
                <div class="title">证书查询</div>
                <div class="list">
                    <div class="single" @click="go(0)">
                        <img src="../assets/osta.png">
                        <div class="btn">中华人民共和国人力资源和社会保障部职业技能鉴定中心
                            <div class="god">去查询 ></div>
                        </div>
                    </div>
                    <div class="single" @click="go(1)">
                        <img src="../assets/ifma.png">
                        <div class="btn">国际财务管理协会中方机构
                            <div class="god">去查询 ></div>
                        </div>
                    </div>
                    <div class="single" @click="go(2)">
                        <img src="../assets/cfo.png">
                        <div class="btn">中国总会计师协会
                            <div class="god">去查询 ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: mapState([
    ]),
    components:{
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'证书查询', href:'/'},
            ]
        }
    },
    mounted(){
    },
    methods: {
        go(index){
            switch (index) {
                case 0:
                    window.open('http://gjzs.osta.org.cn/');
                    break;
                case 1:
                    window.open('http://a.ifm.org.cn/chaxun/2/');
                    break;
                case 2:
                    window.open('https://cacfo.com/searchcert.html');
                    break;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.subcontent{
    width:1120px;
    margin:auto;
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
    .title{
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
    }
    .list{
        width:100%;
        display: flex;
        margin-top: 25px;
        .single{
            width:240px;
            margin-right:30px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            img{
                width:100%;
                height:130px;
            }
            .btn{
                width:100%;
                box-sizing: border-box;
                padding: 15px 21px;
                height: 100px;
                background: #F0F0F0;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #333333;
                font-weight: 400;
                position: relative;
                .god{
                    position: absolute;
                    bottom: 10px;
                    left:20px;
                    font-family: PingFangSC-Semibold;
                    font-size: 14px;
                    color: #235483;
                    letter-spacing: 0.4px;
                    font-weight: 600;
                }
            }
        }
    }
}
</style>
